import React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

// Radix primitives with the same portalled, accessible structure used by shadcn/ui.
export default function AppTooltip({ children, content, side = 'top', align = 'center' }) {
  const [open, setOpen] = React.useState(false);
  if (!content) return children;

  const trigger = React.cloneElement(children, {
    onPointerEnter: (event) => {
      children.props.onPointerEnter?.(event);
      setOpen(true);
    },
    onPointerLeave: (event) => {
      children.props.onPointerLeave?.(event);
      setOpen(false);
    },
    onFocus: (event) => {
      children.props.onFocus?.(event);
      setOpen(true);
    },
    onBlur: (event) => {
      children.props.onBlur?.(event);
      setOpen(false);
    },
  });

  return (
    <TooltipPrimitive.Provider delayDuration={150} skipDelayDuration={100}>
      <TooltipPrimitive.Root open={open} onOpenChange={setOpen}>
        <TooltipPrimitive.Trigger asChild>{trigger}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            align={align}
            sideOffset={8}
            collisionPadding={12}
            className="tw-z-[2000] tw-max-w-[min(20rem,calc(100vw-2rem))] tw-rounded-lg tw-border tw-border-slate-700 tw-bg-slate-900 tw-px-3 tw-py-2 tw-text-left tw-text-xs tw-leading-relaxed tw-text-white tw-shadow-lg"
          >
            {content}
            <TooltipPrimitive.Arrow className="tw-fill-slate-900" />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
